import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ModalWindowComponent } from './modal-window.component';

export type tValidTypes = 'confirm' | 'error' | 'info' | 'wait' | 'warning';

export interface IModalWindowMessageFormat {
    title: string;
    body: string;
    icon: tValidTypes;
    type?: tValidTypes;
}

export { MatDialog, MatDialogRef, MAT_DIALOG_DATA };
// export type { IModalWindowMessageFormat };

@Injectable({
  providedIn: 'root' 
})
export class ModalWindowService {
    // Inyección moderna con inject()
    private readonly _MatDialogS = inject(MatDialog);
    
    public dialogRef: MatDialogRef<any>[] = [];

    // ===========================================================================
    // ---------------------------------------------------------------------------
    public showMessage(msg: string, type: tValidTypes, title = 'Mensaje del sistema', options = {}): Observable<any> {
        const mw_data: IModalWindowMessageFormat = {
            title: title,
            body: msg,
            icon: type
        };
        return this.showComponent(ModalWindowComponent, mw_data, ['system-message'], options);
    }

    // ---------------------------------------------------------------------------
    public showMessageError(msg: string, title = 'Mensaje del sistema'): Observable<any> {
        return this.showMessage(msg, 'error', title);
        // No necesitas subscribirte internamente, quien llama se subscribe
    }

    // ---------------------------------------------------------------------------
    public showMessageWarning(msg: string, title = 'Mensaje del sistema'): Observable<any> {
        return this.showMessage(msg, 'warning', title);
    }

    // ---------------------------------------------------------------------------
    public showMessageInfo(msg: string, title = 'Mensaje del sistema'): Observable<any> {
        return this.showMessage(msg, 'info', title);
    }

    // ---------------------------------------------------------------------------
    public showMessageConfirm(msg: string, title = 'Mensaje del sistema'): Observable<any> {
        return this.showMessage(msg, 'confirm', title);
    }

    // ---------------------------------------------------------------------------
    public showMessageWait(msg: string, title = 'Mensaje del sistema'): Observable<any> {
        return this.showMessage(msg, 'wait', title, { disableClose: true });
    }

    // ---------------------------------------------------------------------------
    // Retorna un Observable que se completa cuando se cierra la ventana
    public showComponent(component: any, mw_data: any, dialog_class: string[] = [], options = {}): Observable<any> {
        const dr = this._MatDialogS.open(component, {
            data: mw_data,
            panelClass: ['message-window', ...dialog_class],
            ...options
        });

        this.dialogRef.push(dr);

        return dr.afterClosed();
    }

    // ---------------------------------------------------------------------------
    // Cierra la última ventana abierta
    public close(): void {
        const last_w = this.dialogRef.pop();
        last_w?.close();
    }
}